import { ReactNode } from "react";
import { Box } from "@mui/material";
import { FieldCitation } from "../addContractButton/createContractPane/CreateContractPane.types.ts";
import ContractAiUpdateCitation from "./ContractAiUpdateCitation.tsx";
import { useContractAiUpdateStyles } from "./ContractAiUpdate.styles.ts";

export interface ContractAiUpdateFieldWrapperProps {
    citation?: FieldCitation;
    onShowInDocument?: (quote: string) => void;
    children: ReactNode;
}

/**
 * Owns the space below a field so the citation link can live in it.
 *
 * The gap between rows was margin on the row itself; moving it here means the link appears inside room that
 * is already reserved, so a row does not grow or shift when the pointer enters it. Both columns use the
 * wrapper, the left one without a citation, which is what keeps the two sides the same height.
 */
function ContractAiUpdateFieldWrapper({ citation, onShowInDocument, children }: ContractAiUpdateFieldWrapperProps) {
    const styles = useContractAiUpdateStyles();

    return (
        <Box sx={styles.fieldWrapper}>
            {children}

            {citation && onShowInDocument && (
                <Box data-citation sx={styles.citationSlot}>
                    <ContractAiUpdateCitation citation={citation} onShowInDocument={onShowInDocument} />
                </Box>
            )}
        </Box>
    );
}

export default ContractAiUpdateFieldWrapper;
